import React from 'react';
import IconBase from './IconBase';

const LinkIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M7,17c-1.4,0-2.6-.5-3.5-1.5s-1.5-2.2-1.5-3.5.5-2.6,1.5-3.5,2.1-1.5,3.5-1.5h3c.3,0,.5,0,.7.3s.3.4.3.7,0,.5-.3.7-.4.3-.7.3h-3c-.8,0-1.5.3-2.1.9s-.9,1.3-.9,2.1.3,1.5.9,2.1,1.3.9,2.1.9h3c.3,0,.5,0,.7.3s.3.4.3.7,0,.5-.3.7-.4.3-.7.3h-3ZM9,13c-.3,0-.5,0-.7-.3s-.3-.4-.3-.7,0-.5.3-.7c.2-.2.4-.3.7-.3h6c.3,0,.5,0,.7.3.2.2.3.4.3.7s0,.5-.3.7-.4.3-.7.3h-6ZM14,17c-.3,0-.5,0-.7-.3s-.3-.4-.3-.7,0-.5.3-.7.4-.3.7-.3h3c.8,0,1.5-.3,2.1-.9s.9-1.3.9-2.1-.3-1.5-.9-2.1-1.3-.9-2.1-.9h-3c-.3,0-.5,0-.7-.3s-.3-.4-.3-.7,0-.5.3-.7.4-.3.7-.3h3c1.4,0,2.6.5,3.5,1.5,1,1,1.5,2.2,1.5,3.5s-.5,2.6-1.5,3.5c-1,1-2.2,1.5-3.5,1.5h-3Z"/>
        </IconBase>
    )
}

export default LinkIcon;